import React, { useMemo } from 'react'
import { AppImages, Theme, variantProvider } from '@/app'
import { View, Text } from '@/components'
import { ItemInfo, OptionItemProps } from './types'

export const OptionItem = <T extends ItemInfo>(props: OptionItemProps<T>) => {
  const { item, selected, onSelectOption } = props

  const wrapperStyle = useMemo(() => ({
    backgroundColor: !selected ? Theme.colors.light.primary1 : Theme.colors.light.neutral1,
    scale: selected ? 1.02 : 1
  }), [selected])

  const imageStyle = useMemo(() => ({ opacity: selected ? 1 : 0 }), [selected])

  const textStyle = useMemo(() => ({ color: !selected ? Theme.colors.light.neutral10 : Theme.colors.light.neutral1 }), [selected])

  return (
    <View onClick={onSelectOption} css={[styles.wrapper, wrapperStyle]}>
      <img src={AppImages.AppTopBg} css={[styles.image, imageStyle]} />
      <Text variants={[!selected ? 'p3' : 'h4']} css={[styles.label, textStyle]} text={item.label ?? item.value} />
    </View>
  )
}

const styles = variantProvider.createComponentStyle(t => ({
  label: {
    fontWeight: '700',
    zIndex: 1,
    transition: 'all 0.2s'
  },
  wrapper: {
    ...t.presets.center,
    ...t.presets.relative,
    ...t.effects.elevated,
    ...t.presets.fullWidth,
    height: t.values.itemHeight.default,
    overflow: 'hidden',
    borderRadius: t.borderRadius.small,
    transition: 'all 0.2s',
    cursor: 'pointer',
    boxShadow: '0px 3.02px 3.02px 0px rgba(0, 0, 0, 0.15)',
  },
  image: {
    ...t.presets.absolute,
    ...t.presets.top,
    ...t.presets.bottom,
    ...t.presets.right,
    ...t.presets.left,
    ...t.presets.fullWidth,
    ...t.presets.fullHeight,
    borderRadius: t.borderRadius.small,
    objectFit: 'cover',
    zIndex: 0,
    transition: 'all 0.2s'
  },
}), true)
